export default class Map_DynamicElementPoint {
  geom;
  constructor(geom) {
    this.geom = geom;
  }

  getGeomLineToGround() {
    const cartesianWGS = this.geom.getGeomHeightWGS();
    const cartesianGround = this.geom.getControlPointCartesian(0);
    return [cartesianWGS, cartesianGround];
  }

  getWKT() {
    let wkt = "";

    wkt = "POINT Z(";
    this.geom.controlspoints.forEach((controlspoint) => {
      wkt +=
        controlspoint.longitude.toFixed(8) +
        " " +
        controlspoint.latitude.toFixed(8) +
        " " +
        this.geom.infos.point["height"].WGS;
    });
    wkt += ")";

    return wkt;
  }

  getEntityPoint() {
    let entity = {
      position: new Cesium.CallbackProperty(() => {
        return this.geom.getGeomHeightWGS();
      }, false),
      billboard: {
        image: `data:image/svg+xml;base64,` + btoa(this.geom.material.getSvgPoint()),
        // image: `data:image/svg+xml,` + this.geom.material.getSvgPoint(),
        color: this.geom.material.getColor(),
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
        scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e7, 0.2),
        pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
          1.0e3,
          0.8,
          1.5e6,
          0.0
        ),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.NONE,
        clampToGround: true,
        scale: 1,
        show: new Cesium.CallbackProperty(() => {
          return this.geom.getVisibility();
        }, false),
      },
      label: {
        text: new Cesium.CallbackProperty(() => {
          return this.geom.getName();
        }),
        fillColor: Cesium.Color.WHITE,
        showBackground: false,
        style: Cesium.LabelStyle.FILL,
        show: new Cesium.CallbackProperty(() => {
          return (
            this.geom.events.isPicked() &&
            this.geom.events.isControlPointClickLeft() == false &&
            this.geom.getName() != "" &&
            this.geom.events.isInsert() == false
          );
        }, false),
        scale: 0.4,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        pixelOffset: new Cesium.Cartesian2(
          0,
          -this.geom.material.getSize() - 5
        ),
      },
      polyline: {
        positions: new Cesium.CallbackProperty(() => {
          return this.geom.point.getGeomLineToGround();
        }, false),
        width: 1,
        material: this.geom.material.getLineMaterial(),
        heightReference: Cesium.HeightReference.NONE,
        show: new Cesium.CallbackProperty(() => {
          return this.geom.getVisibility();
        }, false),
      },
    };
    entity.dynamic = this.geom;
    entity.show = true;
    return entity;
  }
}
